var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrationConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 200,
    viewBox: "0 0 548 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1208_81115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 548,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 548,
    height: 200,
    fill: "#EAFDDC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1208_81115)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 548,
    height: 200,
    fill: "#EAFDDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.066 90.387L295.066 90.387L295.072 90.3809C296.513 88.8905 296.521 86.5417 295.066 85.0865C293.614 83.6346 291.218 83.6346 289.766 85.0865L267.846 107.006L258.233 97.3932C256.781 95.9413 254.384 95.9413 252.932 97.3932C251.481 98.8451 251.481 101.242 252.932 102.694L265.196 114.957C265.895 115.656 266.845 116.057 267.846 116.057C268.847 116.057 269.797 115.656 270.496 114.957L295.066 90.387ZM231.166 100C231.166 76.3996 250.399 57.1667 273.999 57.1667C297.6 57.1667 316.833 76.3996 316.833 100C316.833 123.601 297.6 142.833 273.999 142.833C250.399 142.833 231.166 123.601 231.166 100Z",
    fill: "#96F550",
    stroke: "#121212",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4598 142.5C63.484 141.592 64.6066 141.184 65.2082 141.863L71.4164 148.874C71.6001 149.082 71.8616 149.204 72.1385 149.211L81.5 149.46C82.4071 149.484 82.8157 150.607 82.1364 151.209L75.1251 157.417C74.9177 157.601 74.7958 157.862 74.7884 158.139L74.5393 167.5C74.5152 168.408 73.3926 168.816 72.791 168.137L66.5828 161.126C66.3991 160.918 66.1376 160.796 65.8607 160.789L56.4991 160.54C55.592 160.516 55.1834 159.393 55.8628 158.791L62.8741 152.583C63.0815 152.4 63.2034 152.138 63.2108 151.861L63.4598 142.5Z",
    fill: "#B9F88A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.46 142.5C473.484 141.592 474.607 141.184 475.208 141.863L481.416 148.874C481.6 149.082 481.862 149.204 482.139 149.211L491.5 149.46C492.407 149.484 492.816 150.607 492.136 151.209L485.125 157.417C484.918 157.601 484.796 157.862 484.788 158.139L484.539 167.5C484.515 168.408 483.393 168.816 482.791 168.137L476.583 161.126C476.399 160.918 476.138 160.796 475.861 160.789L466.499 160.54C465.592 160.516 465.183 159.393 465.863 158.791L472.874 152.583C473.081 152.4 473.203 152.138 473.211 151.861L473.46 142.5Z",
    fill: "#B9F88A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 19.375C129.233 18.4679 130.356 18.0593 130.957 18.7386L135.121 23.4412C135.305 23.6486 135.566 23.7706 135.843 23.7779L142.122 23.945C143.029 23.9691 143.438 25.0917 142.759 25.6933L138.056 29.8573C137.849 30.041 137.727 30.3024 137.719 30.5794L137.552 36.8583C137.528 37.7654 136.405 38.174 135.804 37.4947L131.64 32.7921C131.456 32.5847 131.195 32.4627 130.918 32.4554L124.639 32.2883C123.732 32.2642 123.323 31.1416 124.003 30.54L128.705 26.376C128.913 26.1923 129.034 25.9309 129.042 25.6539L129.209 19.375Z",
    fill: "#B9F88A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.553 19.375C409.529 18.4679 408.406 18.0593 407.805 18.7386L403.641 23.4412C403.457 23.6486 403.195 23.7706 402.918 23.7779L396.639 23.945C395.732 23.9691 395.324 25.0917 396.003 25.6933L400.706 29.8573C400.913 30.041 401.035 30.3024 401.042 30.5794L401.209 36.8583C401.234 37.7654 402.356 38.174 402.958 37.4947L407.122 32.7921C407.305 32.5847 407.567 32.4627 407.844 32.4554L414.123 32.2883C415.03 32.2642 415.439 31.1416 414.759 30.54L410.057 26.376C409.849 26.1923 409.727 25.9309 409.72 25.6539L409.553 19.375Z",
    fill: "#B9F88A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationConfirmation);
export default __webpack_public_path__ + "static/media/registration-confirmation.b4db4377bb657d917f2d2756a84ca347.svg";
export { ForwardRef as ReactComponent };